import { Component, createRef } from 'react'
import { Modal, Space, Col, notification, Form, FormInstance } from 'antd'
import { __ } from '../../shared/i18n'
import { AdvancedForm, ModalHeader, ModalAddButton } from '..'
import { StwAttribute } from '../../api'
import { FormValidateMessages } from '../../constants'

interface Props {
  visible: boolean
  title: string
  confirm: any
  close: () => void
  attribute: StwAttribute | undefined
  attributes: any[]
  configuration: any
  edit: boolean
  selectedEntity: any
}

interface State {
  record: any
  optionsCode: any
}

export class ModalAddAttribute extends Component<Props, State> {
  formRef = createRef<FormInstance>()

  state = {
    record: {},
    optionsCode: [],
  }

  componentDidMount = () => {
    const { attribute } = this.props
    if (attribute) {
      this._set(attribute)
    }
  }

  shouldComponentUpdate = (nextProps) => {
    const { record } = this.state
    const { visible } = this.props
    if (JSON.stringify(record) !== JSON.stringify(nextProps.attribute) && nextProps.visible && !visible) {
      this._set(nextProps.attribute)
    }
    return true
  }

  getOptionsCode = () => {
    const { selectedEntity, attributes } = this.props
    const list: any = []
    if (selectedEntity && selectedEntity.options) {
      for (let o = 0; o < selectedEntity.options.length; o++) {
        const find = attributes.find((element) => element.code === selectedEntity.options[o].id)
        if (!find) {
          list.push(selectedEntity.options[o])
        }
      }
    }
    return list
  }

  _set = (attr) => {
    this.setState({
      record: attr,
      optionsCode: this.getOptionsCode(),
    })
    if (this.formRef && this.formRef.current) {
      this.formRef.current.setFieldsValue(attr)
    }
  }

  handleChange = (field, val) => {
    const { record } = this.state
    if (val === '' && field !== 'code') {
      val = undefined
    }
    this.setState({
      record: {
        ...(record || {}),
        [field]: val,
      },
    })
  }

  save = () => {
    const { confirm, configuration } = this.props
    const { record } = this.state
    let c = 0
    let error = false
    while (c < configuration.length && !error) {
      if (configuration[c].rules[0].required && record[configuration[c].key] === '') {
        this.openNotification(__('misc.validationError'), configuration[c].error || __('misc.genericErrorRequired'))
        error = true
      }
      if (
        configuration[c].editable &&
        configuration[c].checkDuplicate &&
        this.checkDuplicate(record[configuration[c].key], configuration[c].field)
      ) {
        this.openNotification(
          __('misc.validationError'),
          configuration[c].duplicate || __('misc.genericErrorDuplicate')
        )
        error = true
      }
      c++
    }

    if (!error) {
      confirm(record)
    }
  }

  checkDuplicate = (key, field) => {
    const tmp: StwAttribute[] = this.props.attributes
    const index = tmp.findIndex((attribute) => attribute[field] === key)
    return index !== -1
  }

  openNotification = (title, text) => {
    notification.error({
      message: title,
      description: text,
      placement: 'bottomRight',
      duration: 3,
    })
  }

  render() {
    const { title, visible, configuration, close } = this.props
    const { record, optionsCode } = this.state
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const thisRef = this
    return (
      <Modal
        centered
        title={<ModalHeader close={close} title={title} />}
        open={visible}
        footer={null}
        closable={false}
        onCancel={() => close()}
        width="30%"
        className="stw-workstation-rfid-antennas-modal"
      >
        <Col span={24}>
          {record && (
            <Form
              ref={this.formRef}
              layout="vertical"
              onFinish={async () => {
                this.save()
              }}
              style={{ width: '100%', height: '100%' }}
              initialValues={record}
              validateMessages={FormValidateMessages}
            >
              <Space size="small" style={{ width: '100%' }} className="stylewhere-form-attributes" direction="vertical">
                {configuration &&
                  configuration.map((column) => {
                    return (
                      <AdvancedForm
                        key={column.key}
                        record={record}
                        handleChange={(k, val) => thisRef.handleChange(column.key, val)}
                        parameters={{ optionsCode: optionsCode }}
                        fields={[
                          {
                            key: column.key,
                            label: column.label,
                            placeholder: column.placeholder,
                            type: column.type,
                            rules: column.rules,
                            col: 24,
                            option: column.option || '',
                            rows: column.rows || 10,
                            readonly: () => !column.editable,
                          },
                        ]}
                      />
                    )
                  })}
                <ModalAddButton mTop={0} close={close} save={this.save} pb={5} />
              </Space>
            </Form>
          )}
        </Col>
      </Modal>
    )
  }
}
